import { TableCellTypes } from '@carboledger/ui';
import { CellText } from '@/components/common';
import {
  CUSTOMER_TRANSPORT_COLUMNS,
  TRANSPORT_MODES,
  TRANSPORT_MODE_COLUMN_KEYS,
} from './transportation.constants';
import { makeSerialCell } from '@/components/common';
import { buildEditDeleteColumn } from './customerRowActions';

const textColumn = (id, header, width) => ({ id, header, type: TableCellTypes.text, width });

const makeModeCell = (mode, field) => {
  const renderModeValue = (ctx) => <CellText>{ctx.row.byMode[mode][field]}</CellText>;
  return renderModeValue;
};

const modeColumns = (t, mode) =>
  Object.entries(TRANSPORT_MODE_COLUMN_KEYS[mode]).map(([field, key]) => ({
    id: `${mode}-${field}`,
    header: t(key),
    type: TableCellTypes.custom,
    width: 180,
    cell: makeModeCell(mode, field),
  }));

// Transport routes are one unpaginated read, so sorting stays off.
export const buildCustomerTransportationColumns = (t, { onEdit, onDelete }) => [
  {
    id: CUSTOMER_TRANSPORT_COLUMNS.serialNo,
    header: t('FIELD_SERIAL_NO'),
    type: TableCellTypes.custom,
    width: 80,
    cell: makeSerialCell(),
  },
  {
    ...textColumn(CUSTOMER_TRANSPORT_COLUMNS.routeName, t('FIELD_ROUTE_NAME'), 180),
    pinnable: true,
  },
  textColumn(CUSTOMER_TRANSPORT_COLUMNS.shippingFrom, t('FIELD_SHIPPING_FROM'), 180),
  textColumn(CUSTOMER_TRANSPORT_COLUMNS.sentTo, t('FIELD_SENT_TO'), 180),
  textColumn(
    CUSTOMER_TRANSPORT_COLUMNS.totalEmissions,
    t('FIELD_TOTAL_TRANSPORTATION_EMISSIONS'),
    240,
  ),
  ...TRANSPORT_MODES.flatMap((mode) => modeColumns(t, mode)),
  buildEditDeleteColumn(t, CUSTOMER_TRANSPORT_COLUMNS.actions, { onEdit, onDelete }),
];
